import React, { useState, useEffect } from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  MenuItem,
  Box
} from '@mui/material';
import api from '../../api/api';

const CreateEditUserDialog = ({ open, handleClose, user, onSave }) => {
  const [formValues, setFormValues] = useState({
    employeeCode: '',
    name: '',
    email: '',
    password: '',
    roleId: '',
    departmentId: ''
  });
  const [roles, setRoles] = useState([]);
  const [departments, setDepartments] = useState([]);

  useEffect(() => {
    if (user) {
      setFormValues({
        id: user.id,
        employeeCode: user.employeeCode || '',
        name: user.name || '',
        email: user.email || '',
        password: user.password || '', 
        roleId: user.roleId || '',
        departmentId: user.departmentId || '',
        secret: user.secret || ''
      });
    } else {
      setFormValues({
        employeeCode: '',
        name: '',
        email: '',
        password: '',
        roleId: '',
        departmentId: '',
        secret: 'dummy_secret'
      });
    }
  }, [user]);

  useEffect(() => {
    fetchRoles();
    fetchDepartments();
  }, []);

  const fetchRoles = async () => {
    try {
      const response = await api.get('/api/Users/Roles');
      setRoles(response.data);
    } catch (error) {
      console.error('Error fetching roles', error);
    }
  };

  const fetchDepartments = async () => {
    try {
      const response = await api.get('/api/Departments');
      setDepartments(response.data);
    } catch (error) {
      console.error('Error fetching departments', error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };

  const handleSubmit = async () => {
    if (user) {
      await api.put(`/api/Users/${user.id}`, formValues);
    } else {
      await api.post('/api/Users', formValues);
    }
    onSave();
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <form onSubmit={handleSubmit}>
        <DialogTitle>{user ? 'Update User' : 'Create User'}</DialogTitle>
        <DialogContent>
          <Box>
            <TextField
              margin="dense"
              name="employeeCode"
              label="Employee Code"
              type="text"
              fullWidth
              value={formValues.employeeCode}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
            <TextField
              margin="dense"
              name="name"
              label="Name"
              type="text"
              fullWidth
              value={formValues.name}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
            <TextField
              margin="dense"
              name="email"
              label="Email"
              type="email"
              fullWidth
              value={formValues.email}
              onChange={handleInputChange}
              inputProps={{ required: true }}
            />
            {!user && (
              <TextField
                margin="dense"
                name="password"
                label="Password"
                type="password"
                fullWidth
                value={formValues.password}
                onChange={handleInputChange}
                inputProps={{ required: !user }}
              />
            )}
            <TextField
              margin="dense"
              label="Role"
              name="roleId"
              value={formValues.roleId}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              select
            >
              {roles.map((role) => (
                <MenuItem key={role.id} value={role.id}>
                  {role.name}
                </MenuItem>
              ))}
            </TextField>
            <TextField
              margin="dense"
              label="Department"
              name="departmentId"
              value={formValues.departmentId}
              onChange={handleInputChange}
              inputProps={{ required: true }}
              fullWidth
              select
            >
              {departments.map((department) => (
                <MenuItem key={department.id} value={department.id}>
                  {department.name}
                </MenuItem>
              ))}
            </TextField>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type='submit' variant="contained" color="primary">
            {user ? 'Update' : 'Create'}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default CreateEditUserDialog;
